import React, { Component, Fragment } from "react";
import VisitMainContainer from "./../../../containers/activite/visit/MainContainer";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "./../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import MenuActivite from "../Menu";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("activite");
    this.props.setMenuLeftIndex("visits");
    this.props.setMenuLeftContent(MenuActivite);
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return <VisitMainContainer />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentClientLabel: (state.currentClient || {}).label
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// src/pages/activite/visit/Home.js